/**
 * Clouds that can appear on a stage or replication. Mirrors the backend `RuntimeEnvironment`
 * enum, which is what populates these fields.
 */
export enum CloudEnvironment {
    Public = 'Public',
    USSec = 'USSec',
    USNat = 'USNat',
    Bleu = 'Bleu',
    Delos = 'Delos',
    GovSG = 'GovSG',
}